'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'comet';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e003';
var svgPathData = ['M0 309c0 112.1 90.9 203 203 203 72.4 0 139.4-38.6 175.7-101.3L496 208 436.1 212.6 512 0 299.4 75.9 304 16 101.3 133.4C38.6 169.7 0 236.6 0 309zm64-20.6l88.4-12.7 39.6-79 39.6 79 88.4 12.7-64 61.5 15.1 86.8-79.1-41-79.1 41 15.1-86.8-64-61.5z', 'M192 196.8l39.6 79 88.4 12.7-64 61.5 15.1 86.8-79.1-41-79.1 41 15.1-86.8-64-61.5 88.4-12.7 39.6-79z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;